import { ref } from 'vue';
import { PUBLIC_CLIENT_APPLICATION, TOKEN_REQUEST } from './msalConfig';

function useAuth() {
  const token = ref(null);
  const interactionInProgress = ref(false);

  const initializeMsal = async () => {
    await PUBLIC_CLIENT_APPLICATION.initialize();
  };

  const handleSignIn = async () => {
    try {
      const response = await PUBLIC_CLIENT_APPLICATION.handleRedirectPromise();
      if (response === null) {
        await PUBLIC_CLIENT_APPLICATION.loginRedirect(TOKEN_REQUEST);
      } else {
        token.value = response.accessToken;
        PUBLIC_CLIENT_APPLICATION.setActiveAccount(response.account);
      }
    } catch (error) {
      console.log('Signin error: ', error);
    }
  };

  const handleSignOut = () => {
    if (!interactionInProgress.value) {
      interactionInProgress.value = true;
      PUBLIC_CLIENT_APPLICATION.logoutRedirect();
      token.value = null;
      interactionInProgress.value = false;
    }
  };

  return {
    token,
    interactionInProgress,
    initializeMsal,
    handleSignIn,
    handleSignOut,
  };
}

export default useAuth;
